import type { RouteLocationNormalized } from 'vue-router';

interface QueriesModel {
  [key: string]: string
}

function isRouteExists(to: RouteLocationNormalized) {
  const routes = useRouter().getRoutes();

  return routes.some(route => route.name === to.name);
}

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  if (import.meta.client) {
    const routeExists = isRouteExists(to);
    if (!routeExists) {
      return;
    }

    const newQueries = { ...to.query, ...from.query };
    const lastVisitedPage = useCookie('lastVisitedPage', {
      default: () => '/',
      maxAge: 900,
    });
    const lastQueries = useCookie('lastQueries', {
      default: (): QueriesModel => {
        return {};
      },
      maxAge: 900,
    });

    if (
      lastVisitedPage.value
      && lastVisitedPage.value !== '/'
      && lastVisitedPage.value !== '/bill'
      && to.path !== '/bill'
      && to.path === from.path
      && to.path === '/'
    ) {
      let queries = newQueries as QueriesModel || {};
      if (lastQueries.value) {
        const parsedQueries = lastQueries.value as QueriesModel || {};
        queries = { ...queries, ...parsedQueries };
      }
      return navigateTo({ path: lastVisitedPage.value, query: queries as QueriesModel });
    }
    lastVisitedPage.value = to.path;
    lastQueries.value = newQueries as QueriesModel || {};

    if (
      Object.keys(to.query).length === 0
      && to.fullPath !== from.fullPath
      && Object.keys(newQueries).length > 0
    ) {
      return navigateTo({ ...to, query: newQueries });
    }
  }
});
